import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'navaar-best-seller-icon',
  template:`<svg [ngStyle]="style" xmlns="http://www.w3.org/2000/svg" width="17" height="14" viewBox="0 0 17 14">
  <rect id="Rectangle_2289" data-name="Rectangle 2289" width="17" height="14" rx="4" fill="#ff6700"/>
  <g id="fire" transform="translate(-60 0)">
    <g id="Group_4009"   data-name="Group 4009" transform="translate(64 1)">
      <path id="Path_3106" data-name="Path 3106" d="M72.576,6.714a6.759,6.759,0,0,0-1.63-3.728A4.473,4.473,0,0,1,69.734.239.239.239,0,0,0,69.6.027a.237.237,0,0,0-.248.018,6.076,6.076,0,0,0-2.243,3.241,10.581,10.581,0,0,0-.246,2.423c-.974-.208-1.2-1.665-1.2-1.681a.239.239,0,0,0-.341-.181c-.051.025-1.254.636-1.324,3.076C64,7,64,7.086,64,7.167a4.305,4.305,0,0,0,4.3,4.3h.013a4.305,4.305,0,0,0,4.288-4.3C72.6,7.048,72.576,6.714,72.576,6.714ZM68.3,10.99a1.484,1.484,0,0,1-1.433-1.527c0-.029,0-.058,0-.093a1.937,1.937,0,0,1,.151-.759.872.872,0,0,0,.789.571.239.239,0,0,0,.239-.239,4.779,4.779,0,0,1,.092-1.087,2.31,2.31,0,0,1,.484-.916,3.078,3.078,0,0,0,.493.9,2.722,2.722,0,0,1,.612,1.492c0,.041.006.082.006.127A1.484,1.484,0,0,1,68.3,10.99Z" transform="translate(-64 0)" fill="#403f49"/>
    </g>
  </g>
</svg>
`

})
export class BestSellerIconComponent  {
  @Input() public style: object = {};
  constructor() { }
}
